<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="cont" epub:type="toc" role="doc-toc">
<header>
<p class="SP"> </p>
<span aria-label="vi" id="pg_vi" role="doc-pagebreak">
<h1 class="FMHF" id="cont"><span aria-label="vii" id="pg_vii" role="doc-pagebreak"><span class="ePub_ePub-SC">CONTENTS</span></span></h1>
</span></header>
<ol class="toc">
<li class="CFMH" id="c_for"><a href="#/xhtml/foreword"><span class="ePub-I">Foreword</span></a></li>
<li class="CFMAU"><span class="ePub-I">Bill Richardson</span></li>
<li class="CCT" id="c_ch1"><a href="#/xhtml/chapter1">  1.  College Residency, Race, and Reaction: Before 1996</a></li>
<li class="CCT" id="c_ch2"><a href="#/xhtml/chapter2">  2.  2001–2010 State DREAM Acts and Litigation</a></li>
<li class="CCT" id="c_ch3"><a href="#/xhtml/chapter3">  3.  The DREAM Act in Congress and Federal Developments</a></li>
<li class="CCT" id="c_ch4"><span href="#/xhtml/chapter4" title="Link target outside of Sample">  4.  The Aftermath of the DREAM Act Defeats, State Developments</span></li>
<li class="CCT" id="c_ch5"><span href="#/xhtml/chapter5" title="Link target outside of Sample">  5.  The DREAM Act and Prosecutorial Discretion: The Birth of DACA</span></li>
<li class="CCT" id="c_ch6"><span href="#/xhtml/chapter6" title="Link target outside of Sample">  6.  Undocumented Lawyers, DACA, and Occupational Licensing</span></li>
<li class="CCT" id="c_ch7"><span href="#/xhtml/chapter7" title="Link target outside of Sample">  7.  The 2016 Election of Donald Trump, the Rescission of DACA, and Its Aftermath</span></li>
<li class="CBMH" id="c_ch8"><span href="#/xhtml/conclusion" title="Link target outside of Sample">Conclusion: Awakening from the DREAM</span></li>
<li class="CBMHF" id="c_ack"><span href="#/xhtml/acknowledgments" title="Link target outside of Sample"><span class="ePub-I">Acknowledgments</span></span></li>
<li class="CBMH" id="c_app1"><span href="#/xhtml/appendix_1" title="Link target outside of Sample"><span class="ePub-I">Appendix 1. State Laws Allowing Undocumented College Students to Establish Residency, 2019</span></span></li>
<li class="CBMH" id="c_app2"><span href="#/xhtml/appendix_2" title="Link target outside of Sample"><span class="ePub-I">Appendix 2. States Restricting Access to Postsecondary Education for Undocumented/DACA Students through April 2019</span></span></li>
<li class="CBMH" id="c_app3"><span aria-label="viii" id="pg_viii" role="doc-pagebreak"><span href="#/xhtml/appendix_3" title="Link target outside of Sample"><span class="ePub-I">Appendix 3. Cases Involving Citizens, Residency, Tuition Benefits/Status, and the DREAM Act &amp; DACA (through April 2019)</span></span></span></li>
<li class="CBMH" id="c_app4"><span href="#/xhtml/appendix_4" title="Link target outside of Sample"><span class="ePub-I">Appendix 4. Immigration-Related Issues: New York State Education Department Licenses</span></span></li>
<li class="CBMH" id="c_not"><span href="#/xhtml/notes" title="Link target outside of Sample"><span class="ePub-I">Notes</span></span></li>
<li class="CBMH" id="c_bib"><span href="#/xhtml/bibliography" title="Link target outside of Sample"><span class="ePub-I">Bibliography</span></span></li>
<li class="CBMH" id="c_ind"><span href="#/xhtml/index" title="Link target outside of Sample"><span class="ePub-I">Index</span></span></li>
<li class="CBMH" id="c_ata"><span href="#/xhtml/abouttheauthor" title="Link target outside of Sample"><span class="ePub-I">About the Author</span></span></li>
</ol>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?8b94fd3e